import { App } from "vue";

import { CInput, CTextarea } from "./input";
import CCheckbox from "./checkbox";
import CForm from "./form";
import CFormItem from "./form-item";

export * from "./type";

export default function install(app: App) {
  //表单组件
  app.component("CInput", CInput);
  app.component("CTextarea", CTextarea);
  app.component("CCheckbox", CCheckbox);
  app.component("CFormItem", CFormItem);
  app.component("CForm", CForm);
}
